<script lang="ts">
  import ProblemNotice from './ProblemNotice.svelte'
  import { appProblem } from './problems'
  import { onMount } from 'svelte'
  import { t } from './i18n.svelte'
  import { live, refreshLive } from './live.svelte'
  import { navigate } from './router.svelte'
  import { errorMessage, hideMini, hideOverlay, stopMarks, stopStream } from './tauri'

  let now = $state(Date.now())
  let stopping = $state(false)
  let error = $state<string | null>(null)

  onMount(() => {
    const timer = setInterval(() => (now = Date.now()), 1000)
    return () => clearInterval(timer)
  })

  const elapsed = $derived.by(() => {
    const total = live.room ? Math.max(0, Math.floor((now - live.room.startedAt) / 1000)) : 0
    const pad = (n: number) => String(n).padStart(2, '0')
    return `${pad(Math.floor(total / 3600))}:${pad(Math.floor((total % 3600) / 60))}:${pad(total % 60)}`
  })

  async function stop() {
    stopping = true
    error = null
    try {
      await stopStream()
      void hideMini().catch(() => {})
      void hideOverlay().catch(() => {})
      void stopMarks().catch(() => {})
      await refreshLive()
    } catch (err) {
      error = errorMessage(err)
    } finally {
      stopping = false
    }
  }
</script>

{#if live.room}
  <div class="live-bar" role="status">
    <span class="live-pill"><span class="dot"></span>LIVE</span>
    <span class="live-bar__timer">{elapsed}</span>
    <strong class="live-bar__title">{live.room.title}</strong>
    <span class="live-bar__meta">· {t('{n} watching', { n: live.room.viewers })}</span>
    <span style="flex: 1"></span>
    <button type="button" class="live-bar__back" onclick={() => navigate('/host')}>
      {t('Back to stream')} →
    </button>
    <button type="button" class="live-bar__stop" onclick={stop} disabled={stopping}>
      {t('Stop')}
    </button>
  </div>
  {#if error}<ProblemNotice problem={appProblem(error, 'sharing')} compact />{/if}
{/if}
